export enum TrackEventCategory {
  LOGIN_VIA_MAIL = 'Login-via-Mail',
  DOCUMENT_UPLOAD = 'Dokument-Upload',
  CONTRACT = 'Vertrag',
  CHECKUP = 'Check-up',
  DOCUMENT_SEARCH = 'Dokumentensuche',
  CONTRACT_SEARCH = 'Vertragssuche',
  BANK_ACCOUNT = 'Bankkonto',
  CONTACT_DATA = 'Kontaktinformationen',
  AI_CONTRACT_EXTRACTION = 'KI-Extraktion',
  CREATE_CONTRACT = 'Vertragserstellung',
  AI_CREATE_CONTRACT = 'Vertragserstellung-KI',
  AI_EXTRACTION_CANCEL_WHILE_EXTRACT = 'KI-Abbruch-bei-Extraktion',
  CONTRACT_SUGGESTION = 'Vertragsvorschlag',
  BANKS_API = 'Banks-API',
  BANK_ACCOUNT_SUGGESTION = 'Bankverbindungsvorschlag',
}
